var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.hidden && _vm.item.children
    ? _c(
        "div",
        { staticClass: "menu-wrapper" },
        [
          _vm.hasOneShowingChild(_vm.item.children, _vm.item) &&
          (!_vm.onlyOneChild.children || _vm.onlyOneChild.noShowingChildren) &&
          !_vm.item.alwaysShow
            ? [
                _c(
                  "menu-link",
                  { attrs: { to: _vm.resolvePath(_vm.onlyOneChild.path) } },
                  [
                    _c(
                      "el-menu-item",
                      {
                        class: { "submenu-title-noDropdown": !_vm.isNest },
                        attrs: { index: _vm.resolvePath(_vm.onlyOneChild.path) }
                      },
                      [
                        _c("svg-icon", {
                          attrs: {
                            "icon-class":
                              _vm.onlyOneChild.meta.icon || _vm.item.meta.icon
                          }
                        }),
                        _vm._v(" "),
                        _vm.onlyOneChild.meta
                          ? _c(
                              "span",
                              { attrs: { title: _vm.onlyOneChild.meta.title } },
                              [_vm._v(_vm._s(_vm.onlyOneChild.meta.title))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _c(
                "el-submenu",
                { attrs: { index: _vm.resolvePath(_vm.item.path) } },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c("svg-icon", {
                        attrs: { "icon-class": _vm.item.meta.icon }
                      }),
                      _vm._v(" "),
                      _vm.item.meta
                        ? _c(
                            "span",
                            { attrs: { title: _vm.item.meta.title } },
                            [_vm._v(_vm._s(_vm.item.meta.title))]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.item.children, function(child) {
                    return [
                      !child.hidden
                        ? [
                            child.children && child.children.length > 0
                              ? _c("sidebar-item", {
                                  key: child.path,
                                  staticClass: "nest-menu",
                                  attrs: {
                                    "is-nest": true,
                                    item: child,
                                    "base-path": _vm.resolvePath(child.path)
                                  }
                                })
                              : _c(
                                  "menu-link",
                                  {
                                    key: child.name,
                                    attrs: { to: _vm.resolvePath(child.path) }
                                  },
                                  [
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          index: _vm.resolvePath(child.path)
                                        }
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            "icon-class": child.meta.icon
                                          }
                                        }),
                                        _vm._v(" "),
                                        child.meta.title
                                          ? _c(
                                              "span",
                                              {
                                                attrs: {
                                                  title: child.meta.title
                                                }
                                              },
                                              [_vm._v(_vm._s(child.meta.title))]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ]
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-344d0b88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-344d0b88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/SideBarItem.vue
// module id = 430
// module chunks = 75